import { render } from "./ModuleRenderer.vue?vue&type=template&id=46f0b1db"
import script from "./ModuleRenderer.vue?vue&type=script&lang=js"
export * from "./ModuleRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__